import React from "react";
import { useSiteContext } from "../../../../../context/SiteContext";
import { useEditCtaContext } from "../../../../../context/EditCtaContext";

const VerticalTemplateOneOneZero = ({
  // Main heading text
  titleText,
  titleFont,
  titleFontSize,
  titleColor,
  titleTextAlign,
  titleIsBold,
  titleIsItalic,
  titleIsUnderline,
  titleLetterSpacing,
  // Subtitle text
  subtitleText,
  subtitleFont,
  subtitleColor = "#FFFFFF",
  subtitleFontSize,
  subtitleTextAlign,
  subtitleIsBold,
  subtitleIsItalic,
  subtitleIsUnderline,

  // Button defaults
  buttonLabel,
  buttonFont = "Helvetica",
  buttonIsBold = false,
  buttonIsItalic = false,
  buttonIsUnderline = false,
  buttonLink = "",
  buttonFontSize = "23",
  buttonSize = "23",
  buttonFontColor = "#D8D8D8",
  buttonBackgroundColor = "#0BA007",

  // Background
  backgroundColor,
  backgroundImage,
  backgroundImagePreview,

  preview = false,
  inmeeting = false,
  onClose,
  position = "left",
}) => {
  if (
    (backgroundImage && ![null, "null"].includes(backgroundImage)) ||
    backgroundImagePreview
  )
    backgroundColor = "";
  const { meetingRole, setActiveElement } = useSiteContext();
  const { explicitBoleanCheck } = useEditCtaContext();
  const isMobile = typeof window !== "undefined" && window.innerWidth <= 767;

  return (
    <div
      className={`relative ${
        !inmeeting
          ? "h-full"
          : isMobile
          ? "h-full"
          : `!h-[91.7vh] w-72 mt-[12%] ${
              position === "left" ? "left-[-55px]" : "right-[-55px]"
            }`
      } ${
        isMobile && inmeeting
          ? position === "left" || position === "right"
            ? "" // Let it size naturally
            : "w-full" // Fill container for center/top/bottom
          : "w-72"
      } flex flex-col mx-auto justify-between items-center p-4 md:p-8 overflow-hidden`}
      style={{ backgroundColor }}
    >
      {/* Close Button */}
      {inmeeting && meetingRole === "moderator" && (
        <button
          className="absolute top-2 right-2 z-20 bg-red-500 hover:bg-red-600 text-white rounded-full w-6 h-6 flex items-center justify-center transition-colors"
          title="Close Banner"
          style={{ right: "8px", top: "8px" }}
          onClick={() => {
            if (meetingRole === "moderator") {
              // publishCloseElementSection({
              //   set: true,
              // });
              onClose();
            } else {
              setActiveElement(null);
            }
          }}
        >
          <svg
            className="w-3 h-3"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      )}
      {/* Background Image */}
      {(backgroundImage || backgroundImagePreview) && (
        <div
          className="absolute inset-0 w-full h-full opacity-90"
          style={{
            backgroundImage: `url(${
              backgroundImage instanceof File
                ? backgroundImagePreview
                : backgroundImage
            })`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        />
      )}

      {/* Content Container */}
      <div className="relative z-10 flex flex-col justify-between items-center w-full h-full max-w-md mx-auto">
        {/* Main Heading */}
        <div className="flex-1 flex justify-center">
          <div
            className="text-center leading-none"
            style={{ textAlign: titleTextAlign }}
          >
            <div
              style={{
                color: titleColor,
                fontSize: `${titleFontSize}px`,
                fontFamily: titleFont,
                fontWeight: explicitBoleanCheck(titleIsBold)
                  ? "bold"
                  : "normal",
                fontStyle: explicitBoleanCheck(titleIsItalic)
                  ? "italic"
                  : "normal",
                textDecoration: explicitBoleanCheck(titleIsUnderline)
                  ? "underline"
                  : "none",
                whiteSpace: "pre-line",
                ...(titleLetterSpacing
                  ? { letterSpacing: titleLetterSpacing }
                  : {}),
              }}
            >
              {titleText}
            </div>
          </div>
        </div>

        {/* Subtitle */}
        <div
          className="text-center leading-relaxed mb-14"
          style={{ textAlign: subtitleTextAlign }}
        >
          <div
            style={{
              color: subtitleColor,
              fontSize: `${subtitleFontSize}px`,
              fontFamily: subtitleFont,
              fontWeight: explicitBoleanCheck(subtitleIsBold)
                ? "bold"
                : "normal",
              fontStyle: explicitBoleanCheck(subtitleIsItalic)
                ? "italic"
                : "normal",
              textDecoration: explicitBoleanCheck(subtitleIsUnderline)
                ? "underline"
                : "none",
              whiteSpace: "pre-line",
            }}
          >
            {subtitleText}
          </div>
        </div>
        {/* Button Container */}
        <div className="flex flex-col items-center gap-1 pb-4 md:pb-8">
          {/* Button */}
          <button
            className={`px-10 py-3 md:px-8 md:py-2 rounded-full transition-all duration-200 shadow-lg hover:shadow-xl ${
              buttonLink ? "cursor-pointer" : "cursor-default"
            }`}
            style={{
              backgroundColor: buttonBackgroundColor,
              color: buttonFontColor,
              fontSize: `${buttonFontSize}px`,
              fontFamily: buttonFont,
              fontWeight: explicitBoleanCheck(buttonIsBold) ? "bold" : "normal",
              fontStyle: explicitBoleanCheck(buttonIsItalic)
                ? "italic"
                : "normal",
              textDecoration: explicitBoleanCheck(buttonIsUnderline)
                ? "underline"
                : "none",
            }}
            onClick={() => {
              if (buttonLink) {
                window.open(buttonLink, "_blank");
              }
            }}
          >
            {buttonLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default VerticalTemplateOneOneZero;
